import { atom } from "recoil";

// 씬 인덱스 전역 상태
const sceneIndexAtom = atom({
  key: "sceneIndex",
  default: 0,
});

export default sceneIndexAtom;
